import Joi from '@hapi/joi'

export const dailyHarvesterPerformancesReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Please select valid Estate`,
        "any.required": `Estate required`
    }),
    collectionPointID: Joi.number().label("Division").messages({
        "any.invalid": `Please select valid Division`,
        "any.required": `Division required`
    }),
    gangID: Joi.number().label("gangID").messages({
        "any.invalid": `Please select valid Gang`,
        "any.required": `Gang required`
    }),
    month: Joi.string().invalid("").label("Month").required().messages({
        "any.invalid": `Please select Month`,
        "any.required": `Month required`
    }),
}